import type { LESSON_PLANNER_MODE, LESSON_PLANNER_VIEW, WORKBOOK_TYPE } from 'types';

export const SELECT_LESSON_PLANNER_WORKBOOK = 'SELECT_LESSON_PLANNER_WORKBOOK';
export type SELECT_LESSON_PLANNER_WORKBOOK_ACTION = {
  type: typeof SELECT_LESSON_PLANNER_WORKBOOK;
  workbook: string;
};

export const SELECT_LESSON_PLANNER_NAVBAR_CHANGE = 'SELECT_LESSON_PLANNER_NAVBAR_CHANGE';
export type SELECT_LESSON_PLANNER_NAVBAR_CHANGE_ACTION = {
  type: typeof SELECT_LESSON_PLANNER_NAVBAR_CHANGE;
  attribute: string;
  value: any;
};
export type SET_CURRENT_LESSON_PLAN_WEEK = 'SET_CURRENT_LESSON_PLAN_WEEK';
export const SET_CURRENT_LESSON_PLAN_WEEK = 'SET_CURRENT_LESSON_PLAN_WEEK';

export type SET_NUMBER_OF_WEEKS = 'SET_NUMBER_OF_WEEKS';
export const SET_NUMBER_OF_WEEKS = 'SET_NUMBER_OF_WEEKS';

export type SET_LESSON_PLAN_DAY = 'SET_LESSON_PLAN_DAY';
export const SET_LESSON_PLAN_DAY = 'SET_LESSON_PLAN_DAY';

export type UPDATE_LESSON_PLAN_ENTITY = 'UPDATE_LESSON_PLAN_ENTITY';

export type LessonPlannerAction =
  | SELECT_LESSON_PLANNER_WORKBOOK_ACTION
  | SELECT_LESSON_PLANNER_NAVBAR_CHANGE_ACTION
  | { data: any; type: SET_CURRENT_LESSON_PLAN_WEEK }
  | { data: any; type: SET_NUMBER_OF_WEEKS }
  | { data: any; type: SET_LESSON_PLAN_DAY };

export type LessonPlannerState = {
  workbook: string;
  classroom: any;
  classroomId: string;
  teachingOrder: string;
  mode: LESSON_PLANNER_MODE;
  view: LESSON_PLANNER_VIEW;
  currentlessonPlanWeek: number;
  numberOfWeeks: number | null;
  currentDay: number;
};

/* eslint-disable no-use-before-define */
type GetState = () => { lessonPlanner: LessonPlannerState };
type PromiseAction = Promise<LessonPlannerAction>;
export type Dispatch = (
  action: LessonPlannerAction | ThunkAction | PromiseAction | Array<LessonPlannerAction>
) => any;
export type ThunkAction = (dispatch: Dispatch, getState: GetState) => any;

export type CurrentWorkbookTheme = {
  type: string;
  primaryColor: string;
  secondaryColor: string;
  textColor: string;
};

export type WORKBOOK_TYPE_VARIANT = WORKBOOK_TYPE.TEACHERS_GUIDE | WORKBOOK_TYPE.STUDENT_WORKBOOK;
export type ChipStatus = 'Not Started' | 'Completed' | 'Currently in Use';
